import { createStore } from 'vuex';
import AuthStore from './Modules/User/AuthStore';
import GlobalStore from './Modules/GlobalStore';
import BankID from './Modules/User/BankID';
import RegisterStore from './Modules/User/RegisterStore';
import UserStore from './Modules/User/UserStore';
import Departments from './Modules/User/Departments';
import CertificateStore from './Modules/Certificate/CertificateStore';
import CreateCertificateStore from './Modules/Certificate/CreateCertificateStore';
import SingleCertificate from './Modules/Certificate/SingleCertificate';
import ClientStore from './Modules/Client/ClientStore';
import SettingStore from './Modules/Setting/SettingStore';
import CompetenceStore from './Modules/Competence/CompetenceStore';
import BillingStore from './Modules/Billing/BillingStore';
import SuperAdminStore from './Modules/SuperAdmin/SuperAdminStore';
import EmployeeStore from './Modules/Employee/EmployeeStore';
import OnboardingStore from './Modules/Onboarding/OnboardingStore';
import GlobalModalStore from './Modules/GlobalModalStore';
import AdminStore from './Modules/EmployAdmin/AdminStore';
import UserPermissionStore from './Modules/Views/UserPermissionStore';
import UserReleaseFeaturesStore from './Modules/User/user-release-features';

export const store = createStore({
    modules: {
        GlobalStore,
        // User
        AuthStore,
        BankID,
        RegisterStore,
        UserStore,
        Departments,
        BillingStore,
        // Certs
        CertificateStore,
        CreateCertificateStore,
        SingleCertificate,
        // Other
        ClientStore,
        SettingStore,
        CompetenceStore,
        SuperAdminStore,
        EmployeeStore,
        OnboardingStore,
        GlobalModalStore,
        AdminStore,
        UserPermissionStore,
        UserReleaseFeaturesStore,
    },
    strict: process.env.NODE_ENV !== 'production',
});
